import { render, staticRenderFns } from "./ContentionRequest.vue?vue&type=template&id=b4a564f4&"
import script from "./ContentionRequest.vue?vue&type=script&lang=js&"
export * from "./ContentionRequest.vue?vue&type=script&lang=js&"
import style0 from "./ContentionRequest.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports